import {Card} from "react-bootstrap";
import useEngagement from "@oldDashboard/legacyHooks/useEngagement";
import Loader from "@/components/common/loader/loader";
import UseTotalGpSummary from "@oldDashboard/legacyHooks/UseTotalGpSummary";
import { getFiltersDate } from "@oldDashboard/legacyUtils";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import { TotalGpSummary } from "@oldDashboard/legacyModels/totalGpSummary.model";
import { EngagementData } from "@oldDashboard/legacyModels/engagementData.model";

interface GuidePostKPIsTileProps  { totalGpSummary:TotalGpSummary, engagementData: EngagementData, timePeriods: TimePeriods[], affiliateSelected: any, launchSelected: String, timePeriodSelected: string, searching: boolean}

const GuidePostKPIsTile = (props:GuidePostKPIsTileProps) => {
   
    const {affiliateSelected, launchSelected,timePeriods,timePeriodSelected, searching, totalGpSummary, engagementData } = props;
    const {totalActivated, totalAwaiting } = totalGpSummary;
    const {engagements } = engagementData;
    const { startDate, endDate } = getFiltersDate(timePeriods,timePeriodSelected);
    const { isLoading } = useEngagement({affiliateSelected, launchSelected, timePeriodSelected, startDate, endDate, searching});
    UseTotalGpSummary({launchSelected, timePeriodSelected,startDate, endDate, searching});

    return (
        <Card className="custom-card" style={{height: '250px'}}>
            { isLoading && <Loader/> }
            <Card.Body className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center border-bottom border-block-end-dashed text-center">
                    <div className="px-3 py-4 flex-fill border-end border-inline-end-dashed h-25">
                        <p className="mb-2 fs-24 fw-semibold">{totalActivated}</p>
                        <div className="d-flex align-items-center justify-content-center">
                            <p className="fs-12 text-muted mb-0">Activated <br/>GuidePosts</p>
                        </div>
                    </div>
                    <div className="px-3 py-4 flex-fill border-bottom-dashed border-start-dashed text-center h-50">
                        <p className="mb-2 fs-24 fw-semibold">{totalAwaiting}</p>
                        <div className="d-flex align-items-center justify-content-center">
                            <p className="fs-12 text-muted mb-0">GuidePosts Awaiting<br/> Approval</p>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-wrap align-items-center">
                    <div className="px-3 py-4 flex-fill border-end border-inline-end-dashed w-100 text-center">
                        <p className="mb-2 fs-24 fw-semibold">{engagements}</p>
                        <div className="d-flex justify-content-center">
                            <p className="fs-12 text-muted mb-0">Total Engagements</p>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default GuidePostKPIsTile;

